<script>
import Loading from "@/components/layout/Loading.vue";
import SinResultados from "@/components/layout/SinResultados.vue";
import { mapActions } from "vuex/dist/vuex.common.js";

export default {
  components: {
    Loading,
    SinResultados,
  },
  props: {
    tipoReconocimiento: Object,
    reconocimientos: Array,
    loading: Boolean,
  },
  methods: {
    ...mapActions("VistosModule", ["insertVisto"]),
    toDate(date) {
      const newDate = new Date(date);
      newDate.setDate(newDate.getDate() + 1);

      return newDate
        .toLocaleString("es-CL", {
          day: "numeric",
          month: "numeric",
          year: "numeric",
        })
        .replace(/-/g, ".");
    },
    verDetalle(item) {
      let data_ = {
        id_empresa: this.$ls.get("user").id_empresa_fk,
        id_usuario: this.$ls.get("user").id_usuario,
        id_modulo: "4",
        id_objeto: item.id_reconocimiento,
      };
      this.insertVisto(data_);
      this.$emit("verDetalle", item);
    },
    toggleLike(item) {
      this.$emit("toggleLikeReconocimiento", item);
    },
  },
};
</script>
<template>
  <section id="reconoce-list" class="reconoce-list">
    <Loading v-if="loading" pixeles="200px" />

    <SinResultados v-if="!loading && reconocimientos.length === 0" />

    <template v-if="!loading">
      <div class="row">
        <div
          v-for="item in reconocimientos"
          :key="item.id_reconocimiento"
          class="col-12 col-lg-6 col-xl-4 col-xxl-3 mb-3"
        >
          <div class="card border-0 card-list">
            <div class="card-body">
              <div class="d-flex">
                <div class="flex-grow-1">
                  <div
                    v-if="
                      tipoReconocimiento.label === 'General' ||
                      tipoReconocimiento.label === 'Enviados'
                    "
                    class="d-flex"
                  >
                    <div class="flex-shrink-0">
                      <img
                        v-if="
                          item.reconocidos[0].imagen_perfil ||
                          /.jpg|.jpeg|.png/.test(
                            item.reconocidos[0].imagen_perfil
                          )
                        "
                        :src="item.reconocidos[0].imagen_perfil"
                        width="48"
                        height="48"
                        class="img-object-cover rounded-circle"
                      />
                      <img
                        v-else
                        src="@/assets/img/intranet/header/icono-header-btn-contacto.svg"
                        width="48"
                        height="48"
                        class="img-object-cover rounded-circle"
                      />
                    </div>
                    <div class="flex-grow-1 ms-3">
                      <p class="d-grid text-secondary mb-0">
                        <strong class="ellipsis-custom">
                          {{
                            capitalizeFirstLetter(
                              item.reconocidos[0].primer_nombre
                            )
                          }}
                          {{
                            capitalizeFirstLetter(
                              item.reconocidos[0].apellido_paterno
                            )
                          }}
                        </strong>
                        <span
                          class="text-secondary text-opacity-75 ellipsis-custom"
                        >
                          {{ toDate(item.fecha_creacion) }}
                        </span>
                      </p>
                    </div>
                  </div>
                  <div v-else class="d-flex">
                    <div class="flex-shrink-0">
                      <img
                        v-if="
                          item.reconocedor[0].imagen_perfil ||
                          /.jpg|.jpeg|.png/.test(
                            item.reconocedor[0].imagen_perfil
                          )
                        "
                        :src="item.reconocedor[0].imagen_perfil"
                        width="48"
                        height="48"
                        class="img-object-cover rounded-circle"
                      />
                      <img
                        v-else
                        src="@/assets/img/intranet/header/icono-header-btn-contacto.svg"
                        width="48"
                        height="48"
                        class="img-object-cover rounded-circle"
                      />
                    </div>
                    <div class="flex-grow-1 ms-3">
                      <p class="d-grid text-secondary mb-0">
                        <strong class="ellipsis-custom">
                          {{
                            capitalizeFirstLetter(
                              item.reconocedor[0].primer_nombre
                            )
                          }}
                          {{
                            capitalizeFirstLetter(
                              item.reconocedor[0].apellido_paterno
                            )
                          }}
                        </strong>
                        <span
                          class="text-secondary text-opacity-75 ellipsis-custom"
                        >
                          {{ toDate(item.fecha_creacion) }}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="d-flex align-items-start flex-shrink-0 ms-3">
                  <a
                    @click="verDetalle(item)"
                    href="javascript:"
                    class="color-main"
                    data-bs-toggle="modal"
                    data-bs-target="#modal-detalle-colaborador"
                  >
                    Ver más
                  </a>
                </div>
              </div>

              <div class="d-flex align-items-center text-secondary">
                <template v-if="tipoReconocimiento.label === 'General'">
                  Ha sido
                  <img
                    width="40"
                    height="40"
                    src="@/assets/img/intranet/reconoce/img-card-reconocer@2x.png"
                  />
                  por
                  {{
                    capitalizeFirstLetter(item.reconocedor[0].primer_nombre)
                  }}
                  {{
                    capitalizeFirstLetter(item.reconocedor[0].apellido_paterno)
                  }}
                </template>
                <template v-if="tipoReconocimiento.label == 'Enviados'">
                  Has
                  <img
                    width="40"
                    height="40"
                    src="@/assets/img/intranet/reconoce/img-card-reconocer@2x.png"
                  />
                  por
                  {{
                    capitalizeFirstLetter(
                      item.valor_comportamiento[0].valor.nombre_valor
                    )
                  }}
                </template>
                <template v-if="tipoReconocimiento.label == 'Recibidos'">
                  Te ha
                  <img
                    width="40"
                    height="40"
                    src="@/assets/img/intranet/reconoce/img-card-reconocer@2x.png"
                  />
                  por
                  {{
                    capitalizeFirstLetter(
                      item.valor_comportamiento[0].valor.nombre_valor
                    )
                  }}
                </template>
              </div>
              <div class="flex-shrink-0 d-flex justify-content-end">
                <a
                  href="javascript:"
                  @click="toggleLike(item)"
                  class="card-custom-footer-like color-main"
                >
                  <span v-if="!item.confirm_like" key="regular-heart">
                    <font-awesome-icon
                      icon="fa-solid fa-heart"
                    ></font-awesome-icon>
                  </span>
                  <span v-else key="solid-heart">
                    <font-awesome-icon
                      icon="fa-solid fa-heart"
                      class="color-red"
                    ></font-awesome-icon>
                  </span>
                  <span class="card-custom-footer-like-count">
                    {{ item.likes?.length }}
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </section>
</template>
<style lang="scss"></style>
